import type { SiteSetupStepBehavior } from './types';

/** The first edit step: more content to add, offered next to a change request's own next steps. */
export const FIRST_EDIT_STEP: SiteSetupStepBehavior = {
    changeRequestNextSteps: [
        'Import more content',
        'Add a landing page',
        'Add a section',
        'Add a changelog',
    ],
};
